/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Panel_TitleInputs */

const vi_carrier_panel_title = /** @type {(inputs: Carrier_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vận chuyển qua hãng`)
};

/**

* @param {Carrier_Panel_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_panel_title = /** @type {((inputs?: Carrier_Panel_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Panel_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_panel_title(inputs)
});